var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJ2DataAnalysis(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M63.87 37l-8.45 11.69-13.34-39L30.6 34.38a9.311 9.311 0 00-7.29.42L17 24.09 8.07 39H3v4h7.33L17 31.91l3.18 5.37a9.5 9.5 0 001.25 13.36l-4.3 8.45 3.57 1.82 4.28-8.43a9.48 9.48 0 009.09-16l7.49-16.13 12.61 37L65.91 41h6.92v-4h-8.96zM27.46 48.84a5.5 5.5 0 110-10.999 5.5 5.5 0 010 10.999z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/J2_Data_analysis.20e77046.svg";
export { SvgJ2DataAnalysis as ReactComponent };